'use strict'
import CryptoJS from "crypto-js";
import {JSEncrypt} from 'jsencrypt';

const cryptoUtil = {
    AESDecrypt: (str, key, iv) => {
        var decrypt = CryptoJS.AES.decrypt(str, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});
        var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedStr.toString());
    },
    RSAEncrypt: (data) => {
        data = JSON.stringify(data);
        var RSACrypto = new JSEncrypt();
        RSACrypto.setPublicKey("-----BEGIN PUBLIC KEY-----\r\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDeo0DY+GNe32x7hwKKwzBjMhtN\r\ngWjBTumns+q7qEZ5NzgCMmycNFO16tSgibTUu2xyM/Z5QeMGfOFedtJU+mPp6Fi3\r\nKsB9sYEi7SDh7oG1l76npkGIOUi0dNTen1LsmggqGFQmU1JTNw0p8OGnhCWVC9vR\r\nMarex5vvfAdsrL2tHwIDAQAB\r\n-----END PUBLIC KEY-----\r\n");
        return RSACrypto.encrypt(data)
    },
    getSk: (len) => {
        var skArr = [];
        var COMMONSK = "abcdefghijklmnopqrstuvwxyzABCEDFGHIJKLMNOPQRSTUVWXYZ0123456789";
        for (var i = 0; i < len; i++) {
            skArr.push(COMMONSK[Math.floor(Math.random() * COMMONSK.length)]);
        }
        return skArr.join("")
        // return "ibVQ58RXe51FojAT"
    },
    getKey: (sk) => {
        return CryptoJS.enc.Utf8.parse(sk);
    },
    getIv: (sk) => {
        let md5String = CryptoJS.MD5(sk).toString()
        return CryptoJS.enc.Utf8.parse(md5String.slice(0, 16).toLowerCase());
    },
    getMsgId: function () {
        var time = (new Date()).getTime() + "";
        var skArr = time.split('');
        var COMMONSK = "abcdefghijklmnopqrstuvwxyzABCEDFGHIJKLMNOPQRSTUVWXYZ";
        for (var i = 0; i < 7; i++) {
            var rd = Math.floor(Math.random() * time.length);
            var charStr = COMMONSK[Math.floor(Math.random() * COMMONSK.length)];
            skArr.splice(rd, 0, charStr);
        }
        return skArr.join("");
    }
};

export default cryptoUtil;
